import { Dropdown } from 'components/common'
import { memo, useEffect, useState } from 'react'
import { CheckboxOptions } from 'types/input'
import { fetchStores } from 'utils/api/storeApi'

type Props = {
  setValue: any
  label: string
  name: string
  error?: string
  required?: boolean
  defaultValue?: string
  isActive?: boolean
  withNoneOption?: boolean
}

const StoresDropdown = ({
  setValue,
  error,
  label,
  name,
  required = false,
  defaultValue,
  isActive,
  withNoneOption = false,
}: Props) => {
  const [options, setOptions] = useState<any>([])
  const [loading, setLoading] = useState<boolean>(true)

  const getStores = async () => {
    try {
      const { data } = await fetchStores({
        limit: 500,
        page: 1,
        isActive,
      })
      const stores: CheckboxOptions[] = data?.docs?.map((store: any) => ({
        label: store.storeName,
        value: store._id,
        disabled: false,
      }))

      if (!stores || stores.length <= 0) {
        return setOptions([])
      }

      if (withNoneOption === true) {
        stores.unshift({
          label: '--NONE--',
          value: '',
          disabled: false,
        })
      }

      setOptions(stores)
    } catch (err) {
      setOptions([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getStores()
  }, [])

  if (loading) {
    return <></>
  }

  return (
    <Dropdown
      required={required}
      label={label}
      name={name}
      setValue={setValue}
      error={error}
      defaultValue={defaultValue}
      options={
        options.length <= 0
          ? [
              {
                label: 'No Stores Found',
                value: 'NO_STORES',
                disabled: true,
              },
            ]
          : options
      }
    />
  )
}

export default memo(StoresDropdown)
